// extracted by mini-css-extract-plugin
export default {"parentBranch":"Branch_parentBranch__TC4Y6","name":"Branch_name__1Z1rt","name_active":"Branch_name_active__8knmM","childBranch":"Branch_childBranch__+GJye"};